export default {
  "projets": {
    "heroTitle": "Our Completed Projects",
    "heroSubtitle": "Discover our achievements across Africa: over 1,000 projects in 6 countries",
    "stats": {
      "projects": "Projects Completed",
      "countries": "Countries",
      "capacity": "Installed Capacity"
    },
    "filters": {
      "categoryLabel": "Category",
      "regionLabel": "Region",
      "resultsCount": "{{count}} project{{plural}} found",
      "categories": {
        "tous": "All Projects",
        "micro-reseaux": "Microgrids",
        "industriel": "Industrial",
        "residentiel": "Residential",
        "telecoms": "Telecommunications",
        "btp": "Civil Engineering & Construction",
        "medical": "Medical"
      },
      "regions": {
        "toutes": "All Regions",
        "afrique": "Africa",
        "asie": "Asia",
        "ameriques": "Americas",
        "europe": "Europe"
      }
    },
    "photoGallery": {
      "badge": "Gallery",
      "title": "Photos from Our Worksites",
      "subtitle": "Real images of our installations and on-site work. Click to enlarge.",
      "categories": {
        "tous": "All Worksites",
        "genie-civil": "Civil Engineering",
        "btp": "BTP & Construction",
        "installation-electrique": "Electrical Installation",
        "montage-solaire": "Solar Mounting"
      },
      "emptyState": "No photos in this category"
    },
    "projectCard": {
      "capacity": "Capacity:",
      "beneficiaries": "Beneficiaries:",
      "duration": "Duration:",
      "partners": "Partners:"
    },
    "emptyState": {
      "title": "No Projects Found",
      "description": "Try adjusting your filters to see more results."
    },
    "cta": {
      "title": "Is Your Project Next?",
      "subtitle": "Join our satisfied clients and benefit from our expertise for your renewable energy project.",
      "quoteBtn": "Request a Quote",
      "contactBtn": "Contact Us"
    },
    "list": [
      {
        "titre": "Rural Microgrid Zambia",
        "description": "Complete microgrid installation for the electrification of 12 rural villages with intelligent management system and lithium battery storage.",
        "details": { "beneficiaires": "15,000 inhabitants", "duree": "18 months", "partenaires": "World Bank, Government of Zambia" }
      },
      {
        "titre": "Industrial Complex Mali",
        "description": "Hybrid solar-grid system for industrial zone with energy optimization and 60% reduction in electricity costs.",
        "details": { "beneficiaires": "50 companies", "duree": "24 months", "partenaires": "Government of Mali, African Development Bank" }
      },
      {
        "titre": "University Campus Senegal",
        "description": "Solar installation with storage for university campus, including electric vehicle charging stations.",
        "details": { "beneficiaires": "25,000 students", "duree": "12 months", "partenaires": "Cheikh Anta Diop University, Ministry of Energy of Senegal" }
      },
      {
        "titre": "Rural Hospital Tanzania",
        "description": "Emergency solar system for medical center with continuous power supply and automatic backup.",
        "details": { "beneficiaires": "50,000 patients/year", "duree": "8 months", "partenaires": "WHO, Ministry of Health of Tanzania" }
      },
      {
        "titre": "Telecom Network Benin",
        "description": "Solar power for 50 telecommunications sites with centralized monitoring.",
        "details": { "beneficiaires": "2 million subscribers", "duree": "15 months", "partenaires": "Telecom operators, ARCEP Benin" }
      },
      {
        "titre": "Mini-Grid Togo",
        "description": "Community microgrid for 8 villages with mobile payment system.",
        "details": { "beneficiaires": "12,000 inhabitants", "duree": "20 months", "partenaires": "African Development Bank, FAO" }
      },
      {
        "titre": "Solar Farm Benin",
        "description": "Large solar farm connected to the national grid with solar tracking technology.",
        "details": { "beneficiaires": "100,000 households", "duree": "30 months", "partenaires": "ARCEP Benin, European Investment Bank" }
      },
      {
        "titre": "Shopping Center Senegal",
        "description": "Rooftop solar installation with self-consumption and surplus sale.",
        "details": { "beneficiaires": "50,000 visitors/day", "duree": "6 months", "partenaires": "Dakar Trade Center, APIX Senegal" }
      },
      {
        "titre": "Gold Mine Mali",
        "description": "Hybrid solar-diesel system for mining operation with 40% reduction in fuel consumption.",
        "details": { "beneficiaires": "2,000 employees", "duree": "18 months", "partenaires": "Mining company, IFC" }
      },
      {
        "titre": "Regional Hospital Senegal",
        "description": "Backup solar system for regional hospital with certified medical inverters.",
        "details": { "beneficiaires": "200,000 patients/year", "duree": "10 months", "partenaires": "Ministry of Health of Senegal, French Cooperation" }
      },
      {
        "titre": "Technological University Togo",
        "description": "Smart solar campus with energy management system and research laboratories.",
        "details": { "beneficiaires": "30,000 students", "duree": "14 months", "partenaires": "University of Lomé, UNESCO" }
      },
      {
        "titre": "Telecom Network Benin — Extension",
        "description": "Solar power for 4G/5G infrastructure with high-capacity backup batteries.",
        "details": { "beneficiaires": "5 million subscribers", "duree": "12 months", "partenaires": "MTN Benin, ARTCI" }
      },
      {
        "titre": "MTN Tower Foundations — Benin",
        "description": "Construction of 120 reinforced concrete foundations for self-supporting and guyed telecom towers. Earthworks, rebar assembly, formwork and concrete pouring across 15 sites nationwide.",
        "details": { "beneficiaires": "3 million subscribers", "duree": "10 months", "partenaires": "MTN Benin, Huawei" }
      },
      {
        "titre": "Industrial Steel Framework — Senegal",
        "description": "Fabrication and erection of 850 tons of steel framework for a 12,000 m² logistics warehouse. Truss beams, purlins, bracing and double-skin cladding.",
        "details": { "beneficiaires": "500 jobs created", "duree": "14 months", "partenaires": "Senegalese industrial group, Ericsson" }
      },
      {
        "titre": "Telecom Foundations — Mali",
        "description": "Construction of 200 telecom tower foundations in rural areas. Geotechnical studies, shallow and deep foundations, earthing grids.",
        "details": { "beneficiaires": "1.5 million subscribers", "duree": "8 months", "partenaires": "Orange Mali, Nokia" }
      },
      {
        "titre": "Data Center — Senegal",
        "description": "Turnkey construction of a 3,200 m² data center including structural works, steel framework, waterproofing, technical lots and redundant cooling system.",
        "details": { "beneficiaires": "Regional operators", "duree": "18 months", "partenaires": "Sonatel, Huawei Technologies" }
      }
    ]
  }
};